import Vue from 'vue'
import Router from 'vue-router'
import VueHead from 'vue-head'

import Landing from './components/views/Landing'

// hollo ball
import StoreHB from './components/views/traffic/StoreHB'
import RedirectHB from './components/views/traffic/RedirectHB'
import RedirectHBSC from './components/views/traffic/RedirectHBSC'
import StoreHBSC from './components/views/traffic/StoreHBSC'
import ThumbnailCTCHB from './components/views/traffic/ThumbnailCTCHB'

// ftb
import StoreFTB from './components/views/traffic/StoreFTB'
import StoreFTBSC from './components/views/traffic/StoreFTBSC'
import RedirectFTB from './components/views/traffic/RedirectFTB'
import RedirectFTBSC from './components/views/traffic/RedirectFTBSC'

// hoopstack
import ThumbnailCTCHS from './components/views/traffic/ThumbnailCTCHS'
import ThumbnailCTCHS2 from './components/views/traffic/ThumbnailCTCHS2'
import ThumbnailCTCHS3 from './components/views/traffic/ThumbnailCTCHS3'
import StoreHS from './components/views/traffic/StoreHS'
import StoreHS2 from './components/views/traffic/StoreHS2'

// colorrope
import ThumbnailCTCCR from './components/views/traffic/ThumbnailCTCCR'

// stack master 3d

import ThumbnailCTCSM from './components/views/traffic/ThumbnailCTCSM'

// base pages
import DownloadPage from './components/views/traffic/DownloadPage'
import DownloadPageNew from './components/views/traffic/DownloadPageNew'
import MDDownloadPage from './components/views/traffic/MDDownloadPage'
import DownloadPageDynamic from './components/views/traffic/DownloadPageDynamic'
import StorePage from './components/views/traffic/StorePage'
import StorePageUpdated from './components/views/traffic/StorePageUpdated'

// redirect pages
import RedirectTenjin from './components/views/traffic/RedirectTenjin'

Vue.use(VueHead)
Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
        return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'landing',
      components: { default: Landing }
    },
    ///////////////////////////////////// Traffic Pages

    // Hollo Ball
    {
      path: '/store',
      name: 'StoreHB',
      components: { default: StoreHB }
    },
    {
      path: '/redirect',
      name: 'RedirectHB',
      components: { default: RedirectHB }
    },
    {
      path: '/hb_redirectsc',
      name: 'RedirectHBSC',
      components: { default: RedirectHBSC }
    },
    {
      path: '/hb_storesc',
      name: 'StoreHBSC',
      components: { default: StoreHBSC }
    },
    {
      path: '/hb_download',
      name: 'ThumbnailCTCHB',
      components: { default: ThumbnailCTCHB }
    },
    {
      path: '/hs_download',
      name: 'ThumbnailCTCHS',
      components: { default: ThumbnailCTCHS }
    },
    {
      path: '/hs_store',
      name: 'StoreHS',
      components: { default: StoreHS }
    },
    {
      path: '/hs2_download',
      name: 'ThumbnailCTCHS2',
      components: { default: ThumbnailCTCHS2 }
    },
    {
      path: '/hs2_store',
      name: 'StoreHS2',
      components: { default: StoreHS2 }
    },
    {
      path: '/hs3_download',
      name: 'ThumbnailCTCHS3',
      components: { default: ThumbnailCTCHS3 }
    },
    {
      path: '/sm_download',
      name: 'ThumbnailCTCSM',
      components: { default: ThumbnailCTCSM }
    },
    {
      path: '/bba_store_a',
      name: 'Block Blast Adventures A',
      components: { default: StorePageUpdated },
      props: {
        default: {
          // required
          appName: 'Block Blast Adventures',
          appPrefix: 'bba',
          callbackUrl: "https://blockblastadventures.onelink.me/n5rk/qb5f635b",
          siteId: "BlockBlastAdventuresA",
          icon: require('@/assets/store_files/images/bba/icon.png'),

          // remove those links,use appPrefix to locate images (see how icon is found at StorePageUpdate.vue)
          long1: require('@/assets/store_files/images/bba/1242x2688/1.png'),
          long2: require('@/assets/store_files/images/bba/1242x2688/2.png'),
          long3: require('@/assets/store_files/images/bba/1242x2688/3.png'),
          long4: require('@/assets/store_files/images/bba/1242x2688/4.png'),
          normal1: require('@/assets/store_files/images/bba/1242x2208/1.png'),
          normal2: require('@/assets/store_files/images/bba/1242x2208/2.png'),
          normal3: require('@/assets/store_files/images/bba/1242x2208/3.png'),
          normal4: require('@/assets/store_files/images/bba/1242x2208/4.png'),

          // pixels
          fbPixelId: "964334420912351",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/bba_store_b',
      name: 'Block Blast Adventures B',
      components: { default: StorePageUpdated },
      props: {
        default: {
          // required
          appName: 'Block Blast Adventures',
          appPrefix: 'bba',
          callbackUrl: "https://blockblastadventures.onelink.me/n5rk/qb5f635b",
          siteId: "BlockBlastAdventuresA",
          icon: require('@/assets/store_files/images/bba/icon.png'),

          // remove those links,use appPrefix to locate images (see how icon is found at StorePageUpdate.vue)
          long1: require('@/assets/store_files/images/bba/1242x2688/1_b.png'),
          long2: require('@/assets/store_files/images/bba/1242x2688/2_b.png'),
          long3: require('@/assets/store_files/images/bba/1242x2688/3_b.png'),
          long4: require('@/assets/store_files/images/bba/1242x2688/4_b.png'),
          normal1: require('@/assets/store_files/images/bba/1242x2208/1_b.png'),
          normal2: require('@/assets/store_files/images/bba/1242x2208/2_b.png'),
          normal3: require('@/assets/store_files/images/bba/1242x2208/3_b.png'),
          normal4: require('@/assets/store_files/images/bba/1242x2208/4_b.png'),

          // pixels
          fbPixelId: "964334420912351",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/bba_store_c',
      name: 'Block Blast Adventures C',
      components: { default: StorePageUpdated },
      props: {
        default: {
          // required
          appName: 'Block Blast Adventures',
          appPrefix: 'bba',
          callbackUrl: "https://blockblastadventures.onelink.me/n5rk/qb5f635b",
          siteId: "BlockBlastAdventuresC",
          icon: require('@/assets/store_files/images/bba/icon.png'),

          // remove those links,use appPrefix to locate images (see how icon is found at StorePageUpdate.vue)
          long1: require('@/assets/store_files/images/bba/1242x2688/1_c.png'),
          long2: require('@/assets/store_files/images/bba/1242x2688/2_c.png'),
          long3: require('@/assets/store_files/images/bba/1242x2688/3_c.png'),
          long4: require('@/assets/store_files/images/bba/1242x2688/4_c.png'),
          long5: require('@/assets/store_files/images/bba/1242x2688/5_c.png'),
          normal1: require('@/assets/store_files/images/bba/1242x2208/1_c.png'),
          normal2: require('@/assets/store_files/images/bba/1242x2208/2_c.png'),
          normal3: require('@/assets/store_files/images/bba/1242x2208/3_c.png'),
          normal4: require('@/assets/store_files/images/bba/1242x2208/4_c.png'),
          normal5: require('@/assets/store_files/images/bba/1242x2208/5_c.png'),

          // pixels
          fbPixelId: "964334420912351",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/bba_store_d',
      name: 'Block Blast Adventures D',
      components: { default: StorePageUpdated },
      props: {
        default: {
          // required
          appName: 'Block Blast Adventures',
          appPrefix: 'bba',
          callbackUrl: "https://blockblastadventures.onelink.me/n5rk/qb5f635b",
          siteId: "BlockBlastAdventuresD",
          icon: require('@/assets/store_files/images/bba/icon.png'),

          // remove those links,use appPrefix to locate images (see how icon is found at StorePageUpdate.vue)
          long1: require('@/assets/store_files/images/bba/1242x2208/1_d.png'),
          long2: require('@/assets/store_files/images/bba/1242x2208/2_d.png'),
          long3: require('@/assets/store_files/images/bba/1242x2208/3_d.png'),
          long4: require('@/assets/store_files/images/bba/1242x2208/4_d.png'),
          long5: require('@/assets/store_files/images/bba/1242x2208/5_d.png'),
          normal1: require('@/assets/store_files/images/bba/1242x2688/1_d.png'),
          normal2: require('@/assets/store_files/images/bba/1242x2688/2_d.png'),
          normal3: require('@/assets/store_files/images/bba/1242x2688/3_d.png'),
          normal4: require('@/assets/store_files/images/bba/1242x2688/4_d.png'),
          normal5: require('@/assets/store_files/images/bba/1242x2688/5_d.png'),

          // pixels
          fbPixelId: "964334420912351",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/mdhd_store_a',
      name: 'Mergedom A',
      components: { default: StorePageUpdated },
      props: {
        default: {
          // required
          appName: 'Mergedom',
          appPrefix: 'mergedom',
          callbackUrl: "https://mdhd.onelink.me/uY9U/dee84b1f",
          siteId: "BlockBlastAdventuresA",
          icon: require('@/assets/store_files/images/mergedom/512x512.png'),
        

          // remove those links,use appPrefix to locate images (see how icon is found at StorePageUpdate.vue)
          long1: require('@/assets/store_files/images/mergedom/1242x2688/1.jpg'),
          long2: require('@/assets/store_files/images/mergedom/1242x2688/2.jpg'),
          long3: require('@/assets/store_files/images/mergedom/1242x2688/3.jpg'),
          long4: require('@/assets/store_files/images/mergedom/1242x2688/4.jpg'),
          long5: require('@/assets/store_files/images/mergedom/1242x2688/5.jpg'),
          normal1: require('@/assets/store_files/images/mergedom/1242x2208/1.jpg'),
          normal2: require('@/assets/store_files/images/mergedom/1242x2208/2.jpg'),
          normal3: require('@/assets/store_files/images/mergedom/1242x2208/3.jpg'),
          normal4: require('@/assets/store_files/images/mergedom/1242x2208/4.jpg'),
          normal5: require('@/assets/store_files/images/mergedom/1242x2208/5.jpg'),

          // pixels
          fbPixelId: "585477392832972",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
          description: "Do you see yourself as the best designer ever? It’s time to find out and play your favorite genre — home decoration and design! Mergedom: Home Design combines elements of merge puzzle and decoration games. Unlike other merge games, this one gives you its unique design options and complete control over the creative process of decoration and renovation. Bring your expert eye and show off your skills while playing Mergedom: Home Design!"
        }
      }
    },
    {
      path: '/hs_store_b',
      name: 'Hoop Stack B',
      components: { default: StorePage },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrl: "https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN",
          siteId: "HoopStackB",
          icon: require('@/assets/store_files/images/hoopstack/06_1024.jpg'),
          landing: require('@/assets/store_files/images/hoopstack/landing.png'),

          long1: require('@/assets/store_files/images/hoopstack/b/1242x2688/1242x2688-1.jpg'),
          long2: require('@/assets/store_files/images/hoopstack/b/1242x2688/1242x2688-2.jpg'),
          long3: require('@/assets/store_files/images/hoopstack/b/1242x2688/1242x2688-3.jpg'),
          long4: require('@/assets/store_files/images/hoopstack/b/1242x2688/1242x2688-4.jpg'),
          long5: require('@/assets/store_files/images/hoopstack/b/1242x2688/1242x2688-5.jpg'),
          normal1: require('@/assets/store_files/images/hoopstack/b/1242x2208/1242x2208-1.jpg'),
          normal2: require('@/assets/store_files/images/hoopstack/b/1242x2208/1242x2208-2.jpg'),
          normal3: require('@/assets/store_files/images/hoopstack/b/1242x2208/1242x2208-3.jpg'),
          normal4: require('@/assets/store_files/images/hoopstack/b/1242x2208/1242x2208-4.jpg'),
          normal5: require('@/assets/store_files/images/hoopstack/b/1242x2208/1242x2208-5.jpg'),

          // pixels
          fbPixelId: "596890194430434",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/hs_store_c',
      name: 'Hoop Stack C',
      components: { default: StorePage },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrl: "https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN",
          siteId: "HoopStackC",
          icon: require('@/assets/store_files/images/hoopstack/06_1024.jpg'),
          landing: require('@/assets/store_files/images/hoopstack/landing.png'),

          long1: require('@/assets/store_files/images/hoopstack/a/1242x2688/1.jpg'),
          long2: require('@/assets/store_files/images/hoopstack/a/1242x2688/2.jpg'),
          long3: require('@/assets/store_files/images/hoopstack/a/1242x2688/3.jpg'),
          long4: require('@/assets/store_files/images/hoopstack/a/1242x2688/4.jpg'),
          long5: require('@/assets/store_files/images/hoopstack/a/1242x2688/5.jpg'),
          normal1: require('@/assets/store_files/images/hoopstack/a/1242x2208/1.jpg'),
          normal2: require('@/assets/store_files/images/hoopstack/a/1242x2208/2.jpg'),
          normal3: require('@/assets/store_files/images/hoopstack/a/1242x2208/3.jpg'),
          normal4: require('@/assets/store_files/images/hoopstack/a/1242x2208/4.jpg'),
          normal5: require('@/assets/store_files/images/hoopstack/a/1242x2208/5.jpg'),
          video: require('@/assets/videos/testc.mp4'),

          // pixels
          fbPixelId: "596890194430434",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/hs_store_d',
      name: 'Hoop Stack D',
      components: { default: StorePage },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrl: "https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN",
          siteId: "HoopStackD",
          icon: require('@/assets/store_files/images/hoopstack/06_1024.jpg'),
          landing: require('@/assets/store_files/images/hoopstack/landing.png'),

          long1: require('@/assets/store_files/images/hoopstack/a/1242x2688/1.jpg'),
          long2: require('@/assets/store_files/images/hoopstack/a/1242x2688/2.jpg'),
          long3: require('@/assets/store_files/images/hoopstack/a/1242x2688/3.jpg'),
          long4: require('@/assets/store_files/images/hoopstack/a/1242x2688/4.jpg'),
          long5: require('@/assets/store_files/images/hoopstack/a/1242x2688/5.jpg'),
          normal1: require('@/assets/store_files/images/hoopstack/a/1242x2208/1.jpg'),
          normal2: require('@/assets/store_files/images/hoopstack/a/1242x2208/2.jpg'),
          normal3: require('@/assets/store_files/images/hoopstack/a/1242x2208/3.jpg'),
          normal4: require('@/assets/store_files/images/hoopstack/a/1242x2208/4.jpg'),
          normal5: require('@/assets/store_files/images/hoopstack/a/1242x2208/5.jpg'),
          video: require('@/assets/videos/testd.mp4'),

          // pixels
          fbPixelId: "596890194430434",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/hs_store_e',
      name: 'Hoop Stack E',
      components: { default: StorePage },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrl: "https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN",
          siteId: "HoopStackE",
          icon: require('@/assets/store_files/images/hoopstack/06_1024.jpg'),
          landing: require('@/assets/store_files/images/hoopstack/landing.png'),

          long1: require('@/assets/store_files/images/hoopstack/a/1242x2688/1.jpg'),
          long2: require('@/assets/store_files/images/hoopstack/a/1242x2688/2.jpg'),
          long3: require('@/assets/store_files/images/hoopstack/a/1242x2688/3.jpg'),
          long4: require('@/assets/store_files/images/hoopstack/a/1242x2688/4.jpg'),
          long5: require('@/assets/store_files/images/hoopstack/a/1242x2688/5.jpg'),
          normal1: require('@/assets/store_files/images/hoopstack/a/1242x2208/1.jpg'),
          normal2: require('@/assets/store_files/images/hoopstack/a/1242x2208/2.jpg'),
          normal3: require('@/assets/store_files/images/hoopstack/a/1242x2208/3.jpg'),
          normal4: require('@/assets/store_files/images/hoopstack/a/1242x2208/4.jpg'),
          normal5: require('@/assets/store_files/images/hoopstack/a/1242x2208/5.jpg'),

          // pixels
          fbPixelId: "596890194430434",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a",

          //optionals
          appDescription: "Bigger Games",
          developer: "Bigger Games",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
        }
      }
    },
    {
      path: '/hs_download_and',
      name: 'Hoop Stack Android Download',
      components: { default: DownloadPageNew },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrls: ["https://track.tenjin.io/v0/click/dvqjSg2mj919fsbiblaZe2"],
          siteId: "HoopStackAndroid",
          icons: [require('@/assets/store_files/images/hoopstack/06_1024.jpg'), require('@/assets/store_files/images/hoopstack/06_1024.jpg')],

          // pixels
          fbPixelId: "596890194430434",
          // snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a"
        }
      }
    },
    {
      path: '/hs_download_a',
      name: 'Hoop Stack Download A',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrls: ["https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN"],
          siteId: "hs_download_a",
          icons: [require('@/assets/store_files/images/hoopstack/06_1024.jpg'), require('@/assets/store_files/images/hoopstack/06_1024.jpg')],

          // pixels
          fbPixelId: "596890194430434",
        }
      }
    },
    {
      path: '/cr_download',
      name: 'Color Rope Download',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_download",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/cr_download_1',
      name: 'Color Rope Download 1',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_download_1",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/cr_download_2',
      name: 'Color Rope Download 2',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_download_2",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/cr_download_3',
      name: 'Color Rope Download 3',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_download_3",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/cr_download_4',
      name: 'Color Rope Download 4',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_download_4",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/cr_download_5',
      name: 'Color Rope Download 5',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_download_5",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
          snapPixelId: "b13c8b46-0a18-414f-9453-3cad1393d01a"
        }
      }
    },
    {
      path: '/cr_download/:group',
      name: 'Color Rope Download Dynamic',
      components: { default: DownloadPageDynamic },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_download",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/hs_download/:group',
      name: 'Hoop Stack Download Dynamic',
      components: { default: DownloadPageDynamic },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrls: ["https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN"],
          siteId: "hs_dowload",
          icons: [require('@/assets/store_files/images/hoopstack/06_1024.jpg'), require('@/assets/store_files/images/hoopstack/06_1024.jpg')],

          // pixels
          fbPixelId: "596890194430434",
        }
      }
    },
    {
      path: '/cr_download_and',
      name: 'Color Rope Android Download',
      components: { default: DownloadPage },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/bdwAJaVK4PYcACCgeKzs7a"],
          siteId: "cr_download_and",
          icons: [require('@/assets/store_files/images/colorrope/icon512_and.jpg'), require('@/assets/store_files/images/colorrope/icon512_and.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/sm_download/:group',
      name: 'Stack Master Download Dynamic',
      components: { default: DownloadPageDynamic },
      props: {
        default: {
          // required
          appName: 'Stack Master 3D',
          callbackUrls: ["https://track.tenjin.io/v0/click/eisHmDhq201mvg3m1L4Cjq"],
          siteId: "sm_download",
          icons: [require('@/assets/store_files/images/stackmaster/icon_512.jpg'), require('@/assets/store_files/images/stackmaster/icon_512.jpg')],

          // pixels
          fbPixelId: "1237188729807906",
        }
      }
    },

    // update download page test
    {
      path: '/hs_app',
      name: 'Hoop Stack Download New',
      components: { default: DownloadPageNew },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrls: ["https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN"],
          siteId: "hs_app",
          icons: [require('@/assets/store_files/images/hoopstack/06_1024.jpg'), require('@/assets/store_files/images/hoopstack/06_1024.jpg')],

          // pixels
          fbPixelId: "596890194430434",
        }
      }
    },
    {
      path: '/bba_app',
      name: 'Block Blast Adventures Download',
      components: { default: MDDownloadPage },
      props: {
        default: {
          // required
          appName: 'Block Blast Adventures',
          callbackUrls: ["https://blockblastadventures.onelink.me/n5rk/qb5f635b", "https://blockblastadventures.onelink.me/n5rk/qb5f635b"],
          siteId: "bba_app",
          icons: [require('@/assets/store_files/images/bba/icon.png'), require('@/assets/store_files/images/bba/icon.png')],
          // pixels
          fbPixelId: "964334420912351",
        }
      }
    },
    {
      path: '/mdhd_app',
      name: 'Mergedom Download',
      components: { default: MDDownloadPage },
      props: {
        default: {
          // required
          appName: 'Mergedom: Home Design',
          callbackUrls: ["https://mdhd.onelink.me/uY9U", "https://mdhd.onelink.me/uY9U"],
          siteId: "mdhd_app",
          icons: [require('@/assets/store_files/images/mergedom/512x512.png'), require('@/assets/store_files/images/mergedom/512x512.png')],
          // pixels
          fbPixelId: "585477392832972",
        }
      }
    },
    {
      path: '/hs_red',
      name: 'HS Redirect',
      components: { default: RedirectTenjin },
      props: {
        default: {
          // required
          siteId: "hs_redirect",
          callbackUrls: ["https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN"],

          // pixels
          fbPixelId: "596890194430434",
        }
      }
    },
    {
      path: '/cr_app',
      name: 'Color Rope Download New',
      components: { default: DownloadPageNew },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_app",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "498395984198857",
        }
      }
    },
    {
      path: '/hs_app_2',
      name: 'Hoop Stack Download New 2',
      components: { default: DownloadPageNew },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrls: ["https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN"],
          siteId: "hs_app_2",
          icons: [require('@/assets/store_files/images/hoopstack/06_1024.jpg'), require('@/assets/store_files/images/hoopstack/06_1024.jpg')],

          // pixels
          fbPixelId: "926897417790140",
        }
      }
    },
    {
      path: '/cr_app_2',
      name: 'Color Rope Download New 2',
      components: { default: DownloadPageNew },
      props: {
        default: {
          // required
          appName: 'Color Rope',
          callbackUrls: ["https://track.tenjin.io/v0/click/eWU17B70hbjIiKeFAvstw8"],
          siteId: "cr_app_2",
          icons: [require('@/assets/store_files/images/colorrope/icon512.jpg'), require('@/assets/store_files/images/colorrope/icon512.jpg')],

          // pixels
          fbPixelId: "736290260247133",
        }
      }
    },
    {
      path: '/hs_app_3',
      name: 'Hoop Stack Download New 3',
      components: { default: DownloadPageNew },
      props: {
        default: {
          // required
          appName: 'Hoop Stack',
          callbackUrls: ["https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN"],
          siteId: "hs_app_3",
          icons: [require('@/assets/store_files/images/hoopstack/06_1024.jpg'), require('@/assets/store_files/images/hoopstack/06_1024.jpg')],

          // pixels
          fbPixelId: "3239097759445774",
          snapPixelId: "5a21e83a-014e-4f3a-85e8-76da3ee64bcd"
        }
      }
    }
  ]

  //71,28,103
})



// WEBPACK FOOTER //
// ./src/router.js